import { useContext } from "react";
import { StoreContext } from "../context/StoreContext";
import { getLogoUrl } from "../utils/logoUtils";

/**
 * Hook to get the store logo URL to use as placeholder for product images
 * Falls back to default logo if store logo is not available
 * Safe to use outside StoreProvider (returns default logo)
 */
export const useStoreLogoPlaceholder = (): string => {
  // Safely access store context - may be undefined if not within StoreProvider
  const storeContext = useContext(StoreContext);
  const store = storeContext?.store || null;
  return getLogoUrl(store?.logo, "/logo512.png");
};


